module.exports = __webpack_public_path__ + "img/red-booth-table-4.1fa1e87e.png";